import styled from "styled-components";
import { theme } from "lib";
import Icon from "components/Icon";
import { useTranslation } from "react-i18next";

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px;
`;

const ErrorCard = styled.div`
  background: rgba(231, 80, 93, 0.1);
  border: 1px solid rgba(231, 80, 93, 0.3);
  border-radius: 16px;
  padding: 40px 48px;
  max-width: 420px;
  width: 100%;
  text-align: center;

  @media (max-width: 480px) {
    padding: 32px 24px;
  }
`;

const ErrorIconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(231, 80, 93, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
`;

const ErrorTitle = styled.h2`
  color: ${theme.GREY_90};
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 12px;
`;

const ErrorMessage = styled.p`
  color: ${theme.GREY_60};
  font-size: 15px;
  line-height: 1.5;
  margin: 0 0 24px;
`;

const ErrorButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const RetryButton = styled.button`
  background: ${theme.CORAL};
  color: ${theme.PRIMARY_WHITE};
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;

  &:hover {
    background: ${theme.SECONDARY};
  }

  &:active {
    transform: scale(0.98);
  }
`;

const GoBackButton = styled.button`
  background: transparent;
  color: ${theme.GREY_60};
  border: 1px solid ${theme.GREY_30};
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s, transform 0.1s;

  &:hover {
    border-color: ${theme.GREY_60};
    color: ${theme.GREY_90};
    background: ${theme.GREY_10};
  }

  &:active {
    transform: scale(0.98);
  }
`;

const Error = ({ retryFunction, goBackFunction }) => {
    const { t } = useTranslation();

    return (
        <ErrorContainer>
          <ErrorCard>
            <ErrorIconWrapper>
              <Icon type="warning" dimensions={32} col={theme.CORAL} />
            </ErrorIconWrapper>
            <ErrorTitle>{t('subscription.error.title')}</ErrorTitle>
            <ErrorMessage>
              {t('subscription.error.message')}
            </ErrorMessage>
            <ErrorButtonGroup>
              <RetryButton onClick={retryFunction}>{t('subscription.error.tryAgain')}</RetryButton>
              <GoBackButton onClick={goBackFunction}>{t('subscription.error.goBack')}</GoBackButton>
            </ErrorButtonGroup>
          </ErrorCard>
        </ErrorContainer>
    )
}

export default Error;